import clsx from 'clsx'

import starFill from 'assets/svg/starFill.svg'

import { Icon } from '@/shared/ui/icon'

import styles from './Stars.module.scss'

type StarsProps = {
	rating?: number | null
	onChange?: (rating: number) => void
	size?: 'small' | 'medium' | 'large' | 'catalog'
	mobileCompact?: boolean
}

export const Stars = ({ rating, onChange, size = 'small', mobileCompact }: StarsProps) => (
	<span
		className={clsx(styles.stars, styles[size], mobileCompact && styles.mobileCompact)}
		aria-label={rating ? `Оценка ${rating} из 5` : 'Оценка не выбрана'}>
		{[1, 2, 3, 4, 5].map(value =>
			onChange ? (
				<button
					key={value}
					type="button"
					className={clsx(styles.starButton, value <= (rating ?? 0) ? styles.starActive : styles.starInactive)}
					onClick={() => onChange(value)}>
					<Icon icon={starFill} title="" />
				</button>
			) : (
				<span key={value} className={clsx(styles.star, styles.starInactive)}>
					<Icon icon={starFill} title="" />
					<span
						className={styles.starFill}
						style={{ clipPath: `inset(0 ${100 - Math.max(0, Math.min(1, (rating ?? 0) - (value - 1))) * 100}% 0 0)` }}>
						<Icon icon={starFill} title="" />
					</span>
				</span>
			)
		)}
	</span>
)
